'use memo';

import { SubmitType } from '@urbanx/agx-ui-components';
import GenerationStatus from '../GenerationStatus';

interface AgencyAgreementGeneratingProps {
  generationStatus: GenerationStatus;
  submitType?: SubmitType;
}

const AgencyAgreementGenerating = ({
  generationStatus,
  submitType,
}: AgencyAgreementGeneratingProps) => {
  if (generationStatus === GenerationStatus.Generating) {
    return submitType === SubmitType.GeneratePdf
      ? 'Generating Agreement'
      : 'Sending for signing';
  }

  if (generationStatus === GenerationStatus.Generated) {
    return submitType === SubmitType.GeneratePdf ? 'Complete' : 'Sent';
  }
};

export default AgencyAgreementGenerating;
